import { useCoreAuth } from '@carvana/core-auth';
import { useEffectWithController } from '@carvana/vdp-react-hooks';
import { useContext } from 'react';
import UserContext from '~/contexts/UserContext';
import fetchUserProfile from '~/services/fetchUserProfile';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetUserProfile() {
  const {
    logInFlag,
    user: { setData, setLoaded, setLoading, setError }
  } = useContext(UserContext);
  const { getUserState } = useCoreAuth();
  const { isValidToken } = getUserState();

  useEffectWithController(
    controller => {
      if (!isValidToken) {
        setLoaded();

        return;
      }

      setLoading();

      fetchUserProfile(controller)
        .then(res => {
          setData({
            email: res.email,
            isLoggedIn: true,
            userId: res.customerId
          });
        })
        .catch(
          generateErrorLogger(
            'Get user profile',
            {},
            { controller, callback: setError }
          )
        );
    },
    [isValidToken, logInFlag, setData, setError, setLoaded, setLoading]
  );
}
